import { validateResponseHasSchema } from '@/shared/api/validation'
import { z } from 'zod'
import { ownerSchema } from '@/shared/schemas'
import { createAssetManagementClient } from '@/shared/api/client'

const client = createAssetManagementClient()
export const fetchOwners = () => validateResponseHasSchema(
  client.sendGet('owners'),
  z.object({
    data: z.array(ownerSchema)
  })
).then(
  res => res.data
)
